module.exports = __webpack_public_path__ + "static/media/htmltag.47eef9c4.svg";